import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const CustomDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
    <button onClick={() => handleClickOpen()} className="emergency-btn" id="intubate">Emergency</button>

    <Dialog open={open} onClose={handleClose}>
        <DialogTitle id='alert-dialog-title'>Emergent Intubation</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This will skip the risk assessment and intubation plan steps and go directly to the timeout procedure. Skipped sections should be filled out after the procedure is complete.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <button className="close-btn" onClick={handleClose}>Close</button>
            <button className="intubate-btn" onClick={() => { props.routePatient(props.patient, "intubate"); setOpen(false); }}>Continue</button>
        </DialogActions>
    </Dialog>
    </>
  );
};

export default CustomDialog;
